import MainLayout from './main-layout.vue'
import DefaultLayout from './default-layout.vue'
import LoginLayout from './login-layout.vue'
import DashboardLayout from './dashboard-layout.vue'
export default {
	MainLayout,
	DefaultLayout,
	LoginLayout,
	DashboardLayout
}